const setObjectInUrl = (transition, object) => {
  const { name: routeName } = transition.router.stateService.current;
  transition.router.stateService.go(routeName, object, { notify: false, location: 'replace' });
};

export default setObjectInUrl;
